"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var Controller = {
    Video: "VideoDeliverables",
    Design: "DesignDeliverables",
    Editorial: "EditorialDeliverables",
    Consulting: "ConsultingDeliverables",
    Social: "SocialDeliverables",
    Tech: "TechDeliverables",
    AccountManagement: "AccountManagementDeliverables",
    MasterProject: "AccountManagementDeliverables",
    Production: "AccountManagementDeliverables",
    Idea: "AccountManagementDeliverables",
    Publish: "AccountManagementDeliverables",
};
var ProductService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProductService /> class.
     * @param http
     * @param config
     */
    function ProductService(http, config) {
        this.http = http;
        this.config = config;
    }
    ;
    ProductService.prototype.AddAssetOutcomeAsync = function (deliverableId, addAssetOutcomeRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/addAssetOutcome", addAssetOutcomeRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Add Manual Message
      * @param deliverableId
      * @param transferOwnerRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    ProductService.prototype.AddMessageAsync = function (deliverableId, feedbackRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/addmessage", feedbackRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
        * Adjust Work Slot.
        * @param deliverableId
        * @param addWorkRequest
        * @returns An Observable containing boolean
        */
    ProductService.prototype.AddProjectWorkAsync = function (deliverableId, addWorkRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/addwork", addWorkRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Adjust Work Slot.
      * @param deliverableId
      * @param adjustWorkSlotRequest
      * @returns An Observable containing boolean
      */
    ProductService.prototype.AdjustWorkSlotAsync = function (deliverableId, adjustWorkSlotRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/adjustworkslot", adjustWorkSlotRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Adjust roles.
    * @param deliverableId
    * @param adjustHeadRolesRequest
    * @returns An Observable containing boolean
    */
    ProductService.prototype.AdjustRolesAsync = function (deliverableId, adjustHeadRolesRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/adjustroles", adjustHeadRolesRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Adjust line roles.
    * @param deliverableId
    * @param AdjustLineRolesRequest
    * @returns An Observable containing boolean
    */
    ProductService.prototype.AdjustLineRolesAsync = function (deliverableId, phaseId, adjustLineRolesRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/" + phaseId + "/adjustroles", adjustLineRolesRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Complete Client Phase Async.
     * @param completeClientPhaseRequest
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.AcceptApprovalAsync = function (feedbackRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + feedbackRequest.deliverableId + "/acceptapproval", feedbackRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
       * Adjust Term.
       * @param adjustDeliverableTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    ProductService.prototype.AdjustTermAsync = function (adjustDeliverableTermRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/adjustterm", adjustDeliverableTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
       * Adjust Term.
       * @param adjustDeliverableTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    ProductService.prototype.AdjustPhaseTermAsync = function (adjustPhaseTermRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + adjustPhaseTermRequest.parentDeliverableId + "/" + adjustPhaseTermRequest.phaseId + "/adjustterm", adjustPhaseTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Cancel Project Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.CancelProjectAsync = function (projectId, module, comment) {
        var params = new http_1.HttpParams();
        params = params.set('comment', encodeURI(comment));
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + projectId + "/cancel", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Complete Phase Async.
     * @param completePhaseRequest
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.CompletePhaseAsync = function (completeVideoPhaseRequest, module) {
        var params = new http_1.HttpParams();
        // stupid manual encode of + and & otherwise url breaks...
        if (completeVideoPhaseRequest.completionNotes) {
            var feedback = completeVideoPhaseRequest.completionNotes;
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('completionNotes', feedback);
        }
        if (completeVideoPhaseRequest.completedDate)
            params = params.set('completedDate', completeVideoPhaseRequest.completedDate.toString());
        if (completeVideoPhaseRequest.partialUnits != null)
            params = params.set('partialUnits', completeVideoPhaseRequest.partialUnits.toString());
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + completeVideoPhaseRequest.deliverableId + "/completevideophase", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Complete Async.
     * @param completePhaseRequest
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.CompleteAsync = function (deliverableId, completePhaseRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/complete", completePhaseRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
        * Adjust Work Slot.
        * @param deliverableId
        * @param addWorkRequest
        * @returns An Observable containing boolean
        */
    ProductService.prototype.ConfirmProvisionalLineAsync = function (deliverableId, phaseId, confirmProvisionalLineRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/" + phaseId + "/confirmprovisional", confirmProvisionalLineRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Confirm the schedule of a To be scheduled deliverbale
      * @param ConfirmScheduleRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    ProductService.prototype.ConfirmScheduleAsync = function (confirmScheduleRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + confirmScheduleRequest.deliverableId + "/confirmschedule", confirmScheduleRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Creates an article from an article outcome.
      * @param createArticleFromOutcomeRequest
      * @returns An Observable containing the deliverale article outcome.
      */
    ProductService.prototype.CreateArticleFromOutcomeAsync = function (createArticleFromOutcomeRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + createArticleFromOutcomeRequest.deliverableId + "/createarticlefromoutcome", createArticleFromOutcomeRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Create Async.
      * @param createPartialDeliverableRequest
      * @returns An Observable containing the DeliverableBase
      */
    ProductService.prototype.CreatePartialAsync = function (createPartialDeliverableRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/createpartial", createPartialDeliverableRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Create Async.
      * @param createPartialDeliverableRequest
      * @returns An Observable containing a IDeliverableAggregatePagedList of Delivarables
      */
    ProductService.prototype.CreateMultiAsync = function (createmultiDeliverableRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/createmulti", createmultiDeliverableRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Async.
     * @param createFullDeliverableRequest
     * @returns An Observable containing the DeliverableBase
     */
    ProductService.prototype.CreateFullAsync = function (createFullDeliverableRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/createfull", createFullDeliverableRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Delete.
    * @param id
    * @returns An Observable containing boolean
    */
    ProductService.prototype.DeleteAsync = function (id, module, removeParentPhaseWhenSingleInstance) {
        if (removeParentPhaseWhenSingleInstance == true)
            return this.http.delete(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + id + "/withparent")
                .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
        else
            return this.http.delete(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + id)
                .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * FastForward Async.
   * @param phaseId
   * @returns An Observable containing the boolean
   */
    ProductService.prototype.FastForwardAsync = function (phaseId, module, comment) {
        var params = new http_1.HttpParams();
        // stupid manual encode of + and & otherwise url breaks...
        if (comment) {
            var feedback = comment;
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('comment', feedback);
        }
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + phaseId + "/fastforward", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * ForceComplete Async.
   * @param parentDeliverableId
   * @param phaseId
   * @returns An Observable containing the boolean
   */
    ProductService.prototype.ForceCompleteAsync = function (parentDeliverableId, phaseId, module, comment) {
        var params = new http_1.HttpParams();
        // stupid manual encode of + and & otherwise url breaks...
        if (comment) {
            var feedback = comment;
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('comment', feedback);
        }
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + parentDeliverableId + "/" + phaseId + "/forcecomplete", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Gets a current deliverable phase
   * @param id
   * @returns An Observable containing the SimpleDPhaseWork
   */
    ProductService.prototype.GetPhaseAsync = function (id, module) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/videophase/" + id)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Gets a current deliverable video project
   * @param id
   * @returns An Observable containing the VideoProject
   */
    ProductService.prototype.GetProjectAsync = function (id, module) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + id)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Link an article to an article outcome.
    * @param linkArticleToOutcomeRequest
    * @returns An Observable containing the deliverale article outcome.
    */
    ProductService.prototype.LinkArticleToOutcomeAsync = function (linkArticleToOutcomeRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + linkArticleToOutcomeRequest.deliverableId + "/linkarticletooutcome", linkArticleToOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * returns a list of unallocated video phases
     * @param page
     * @param pageSize
     * @returns An Observable containing the model.IPagedList<SimpleDPhaseWork>
     */
    ProductService.prototype.ListUnAllocatedPhasesAsync = function (page, pageSize, module) {
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/unallocated", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
         * List overdue phases By search parameters
         * @returns An Observable containing the model.IPagedList<VideoPhaseWork>
         */
    ProductService.prototype.ListOverduePhasesAsync = function (page, pageSize, module) {
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/overdue", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * List Phases By search parameters
   * @param listPhasesRequest
   * @returns An Observable containing the IDeliverableAggregatePagedList<Video>
   */
    ProductService.prototype.ListPhasesAsync = function (listVideosPhasesRequest, module) {
        var params = new http_1.HttpParams();
        if (listVideosPhasesRequest.page)
            params = params.set('page', listVideosPhasesRequest.page.toString());
        if (listVideosPhasesRequest.pageSize)
            params = params.set('pageSize', listVideosPhasesRequest.pageSize.toString());
        if (listVideosPhasesRequest.ownerIds)
            params = params.set('ownerIds', listVideosPhasesRequest.ownerIds.toString());
        if (listVideosPhasesRequest.workStatusTypes)
            params = params.set('workStatusTypes', listVideosPhasesRequest.workStatusTypes.toString());
        if (listVideosPhasesRequest.productIds)
            params = params.set('productIds', listVideosPhasesRequest.productIds.toString());
        if (listVideosPhasesRequest.fromDate)
            params = params.set('fromDate', listVideosPhasesRequest.fromDate.toString());
        if (listVideosPhasesRequest.toDate)
            params = params.set('toDate', listVideosPhasesRequest.toDate.toString());
        if (listVideosPhasesRequest.currentPhaseWorkTypeId)
            params = params.set('currentPhaseWorkTypeId', listVideosPhasesRequest.currentPhaseWorkTypeId.toString());
        if (listVideosPhasesRequest.feedId)
            params = params.set('feedId', listVideosPhasesRequest.feedId.toString());
        if (listVideosPhasesRequest.hasUnits != null)
            params = params.set('hasUnits', listVideosPhasesRequest.hasUnits.toString());
        if (listVideosPhasesRequest.orderByCriteria)
            params = params.set('orderByCriteria', listVideosPhasesRequest.orderByCriteria);
        if (listVideosPhasesRequest.createdFrom)
            params = params.set('createdFrom', listVideosPhasesRequest.createdFrom.toString());
        if (listVideosPhasesRequest.businessUnits)
            params = params.set('businessUnits', listVideosPhasesRequest.businessUnits.toString());
        if (listVideosPhasesRequest.productClassIds)
            params = params.set('productClassIds', listVideosPhasesRequest.productClassIds.toString());
        if (listVideosPhasesRequest.productVariantIds)
            params = params.set('productVariantIds', listVideosPhasesRequest.productVariantIds.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/videophases", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List  By search parameters
     * @param listRequest
     * @returns An Observable containing the IDeliverablePagedList<Deliverable>
     */
    ProductService.prototype.ListProjectsAsync = function (listVideoRequest, module) {
        var params = new http_1.HttpParams();
        if (listVideoRequest.page)
            params = params.set('page', listVideoRequest.page.toString());
        if (listVideoRequest.pageSize)
            params = params.set('pageSize', listVideoRequest.pageSize.toString());
        if (listVideoRequest.workStatusTypes)
            params = params.set('workStatusTypes', listVideoRequest.workStatusTypes.toString());
        if (listVideoRequest.productIds)
            params = params.set('productIds', listVideoRequest.productIds.toString());
        if (listVideoRequest.fromDate)
            params = params.set('fromDate', listVideoRequest.fromDate.toString());
        if (listVideoRequest.toDate)
            params = params.set('toDate', listVideoRequest.toDate.toString());
        if (listVideoRequest.currentPhaseWorkTypeId)
            params = params.set('currentPhaseWorkTypeId', listVideoRequest.currentPhaseWorkTypeId.toString());
        if (listVideoRequest.feedId)
            params = params.set('feedId', listVideoRequest.feedId.toString());
        if (listVideoRequest.parentPhaseId)
            params = params.set('parentPhaseId', listVideoRequest.parentPhaseId.toString());
        if (listVideoRequest.orderByCriteria)
            params = params.set('orderByCriteria', listVideoRequest.orderByCriteria);
        if (listVideoRequest.businessUnits)
            params = params.set('businessUnits', listVideoRequest.businessUnits.toString());
        if (listVideoRequest.ownerIds)
            params = params.set('ownerIds', listVideoRequest.ownerIds.toString());
        if (listVideoRequest.ids)
            params = params.set('ids', listVideoRequest.ids.toString());
        if (listVideoRequest.productClassIds)
            params = params.set('productClassIds', listVideoRequest.productClassIds.toString());
        if (listVideoRequest.productVariantIds)
            params = params.set('productVariantIds', listVideoRequest.productVariantIds.toString());
        if (listVideoRequest.missingUnits != null)
            params = params.set('missingUnits', listVideoRequest.missingUnits.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/" + Controller[module.id], { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Gets a list of all phase lines that have uncreated video units still available
     * Effectively - a list of things to create
     * @param listUncreatedRequest
     * @returns An Observable containing the model.IPagedList<model.SimpleDProject>
     */
    ProductService.prototype.ListUnCreatedLines = function (listUncreatedRequest, module) {
        var params = new http_1.HttpParams();
        if (listUncreatedRequest.page)
            params = params.set('page', listUncreatedRequest.page.toString());
        if (listUncreatedRequest.pageSize)
            params = params.set('pageSize', listUncreatedRequest.pageSize.toString());
        if (listUncreatedRequest.fromDate)
            params = params.set('fromDate', listUncreatedRequest.fromDate.toString());
        if (listUncreatedRequest.toDate)
            params = params.set('toDate', listUncreatedRequest.toDate.toString());
        if (listUncreatedRequest.ownerIds)
            params = params.set('ownerIds', listUncreatedRequest.ownerIds.toString());
        if (listUncreatedRequest.feedId)
            params = params.set('feedId', listUncreatedRequest.feedId.toString());
        if (listUncreatedRequest.businessUnits)
            params = params.set('businessUnits', listUncreatedRequest.businessUnits.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/uncreated", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Lock A Deliverable Term Async.
      * @param lockDeliverableTermRequest
      * @returns An Observable containing a boolean
      */
    ProductService.prototype.LockDeliverableTermAsync = function (deliverableId, lockDeliverableTermRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/lock", lockDeliverableTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * OnHold Project Async.
    * @param deliverableId
    * @returns An Observable containing the boolean
    */
    ProductService.prototype.OnHoldProjectAsync = function (projectId, module, comment, hold) {
        if (hold === void 0) { hold = true; }
        var params = new http_1.HttpParams();
        // stupid manual encode of + and & otherwise url breaks...
        if (comment) {
            var feedback = comment;
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('comment', feedback);
        }
        params = params.set('hold', hold.toString());
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + projectId + "/hold", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Poke Async.
     * @param deliverableId
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.PokeAsync = function (deliverableId, module, comment) {
        var params = new http_1.HttpParams();
        // stupid manual encode of + and & otherwise url breaks...
        if (comment) {
            var feedback = comment;
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('comment', feedback);
        }
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/poke", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Provisional Async.
     * @param deliverableId
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.ProvisionalAsync = function (deliverableId, phaseId, module, provisional) {
        var params = new http_1.HttpParams();
        if (provisional !== null)
            params = params.set('provisional', provisional.toString());
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/" + phaseId + "/provisional", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Remove Video Phase Async.
     * @param deliverableId
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.RemovePhaseAsync = function (deliverableId, phaseId, module) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/" + phaseId + "/removephase")
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Complete Client Phase Async.
   * @param completeClientPhaseRequest
   * @returns An Observable containing the boolean
   */
    ProductService.prototype.RejectApprovalAsync = function (approvalFeedbackRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + approvalFeedbackRequest.deliverableId + "/rejectapproval", approvalFeedbackRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Reject a Revision Phase Async.
     * @param RejectRevisionAsync
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.RejectRevisionAsync = function (approvalFeedbackRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + approvalFeedbackRequest.deliverableId + "/rejectrevision", approvalFeedbackRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Reject a Client Approval Phase Async.
     * @param RejectRevisionAsync
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.RejectClientApprovalAsync = function (approvalFeedbackRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + approvalFeedbackRequest.deliverableId + "/rejectclientapproval", approvalFeedbackRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Reset Phase Async.
    * @param deliverableId
    * @param feedback
    * @returns An Observable containing the boolean
    */
    ProductService.prototype.ResetPhaseAsync = function (deliverableId, module, feedback) {
        var params = new http_1.HttpParams();
        if (feedback) {
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('feedback', feedback);
        }
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/resetvideophase", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Restart Deliverable Async.
  * @returns An Observable containing the boolean
  */
    ProductService.prototype.RestartDeliverableAsync = function (deliverableId, module, feedback) {
        var params = new http_1.HttpParams();
        if (feedback) {
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('feedback', feedback);
        }
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/restartdeliverable", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Start Phase Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.StartPhaseAsync = function (deliverableId, module, startedDate) {
        var params = new http_1.HttpParams();
        if (startedDate)
            params = params.set('startedDate', startedDate);
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/startvideophase", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Switch Product Async.
     * @param deliverableId
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.SwitchProductAsync = function (switchProductRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + switchProductRequest.deliverableId + "/" + switchProductRequest.phaseId + "/switchproduct", switchProductRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Terminate Rolling Line
     * @param adjustDeliverableTermRequest
     * @returns An Observable containing the DeliverableBase
     */
    ProductService.prototype.TerminateRollingLineAsync = function (terminateRollingLineRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + terminateRollingLineRequest.parentDeliverableId + "/" + terminateRollingLineRequest.phaseId + "/terminate", terminateRollingLineRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Transfer Owner.
      * @param deliverableId
      * @param transferOwnerRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    ProductService.prototype.TransferOwnerAsync = function (deliverableId, transferOwnerRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/owner", transferOwnerRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * TrimUnassignedUnits Async.
     * @param deliverableId
     * @param feedback
     * @returns An Observable containing the boolean
     */
    ProductService.prototype.TrimUnAssignedUnitsAsync = function (deliverableId, module, feedback) {
        var params = new http_1.HttpParams();
        if (feedback) {
            feedback = feedback.replace("+", "plus");
            feedback = encodeURI(feedback);
            params = params.set('feedback', feedback);
        }
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/trimunassigned", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Put.
      * @param id
      * @param updateDeliverableRequest
      * @returns An Observable containing the DeliverableChildBase
      */
    ProductService.prototype.RenameAsync = function (id, updateDeliverableRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + id, updateDeliverableRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Rename A Pending Phase.
    * @param deliverableId
    * @param renamePhaseRequest
    * @returns An Observable containing boolean
    */
    ProductService.prototype.RenamePhaseAsync = function (deliverableId, renamePhaseRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/renameaphase", renamePhaseRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Put.
      * @param id
      * @param updateDeliverableRequest
      * @returns An Observable containing the DeliverableChildBase
      */
    ProductService.prototype.RequestDateChangeAsync = function (deliverableId, requestDateChangeRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + deliverableId + "/requestdatechange", requestDateChangeRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Mark as To be scheduled
      * @param ToBeScheduledRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    ProductService.prototype.ToBeScheduledAsync = function (toBeScheduledRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + toBeScheduledRequest.deliverableId + "/tobescheduled", toBeScheduledRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * Transfer a contractline to another SOW
      * @param TransferContractLineRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    ProductService.prototype.TransferContractLineAsync = function (transferContractLineRequest, module) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + transferContractLineRequest.sourceContractId + "/" + transferContractLineRequest.phaseId + "/transfercontractline", transferContractLineRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Unlink an article from an article outcome.
  * @param unlinkArticleFromOutcomeRequest
  * @returns An Observable containing the deliverale article outcome.
  */
    ProductService.prototype.UnlinkArticleFromOutcome = function (unlinkArticleFromOutcomeRequest, module) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/" + Controller[module.id] + "/" + unlinkArticleFromOutcomeRequest.deliverableId + "/unlinkarticlefromoutcome", unlinkArticleFromOutcomeRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    ProductService.ngInjectableDef = i0.defineInjectable({ factory: function ProductService_Factory() { return new ProductService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: ProductService, providedIn: "root" });
    ProductService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ProductService);
ProductService.ɵfac = function ProductService_Factory(t) { return new (t || ProductService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
ProductService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProductService, factory: function (t) { return ProductService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProductService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ProductService;
}());
exports.ProductService = ProductService;

